<template>
  <footer class="w-full bg-blue-900 text-white">
    <div class="container mx-auto px-4 py-12">
      <div class="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div class="mb-6 md:mb-0">
          <h3 class="text-xl font-semibold text-white mb-2">
            Fairmont Park LLC
          </h3>
          <p class="text-blue-100">Property Management</p>
        </div>
        <div class="flex flex-col space-y-2">

          <div class="flex items-center">
            <Phone size="18" class="text-amber-400 mr-2" />
            <a
                href="tel:+12014856060"
                class="text-blue-100 hover:text-amber-400 transition-colors"
            >
              +1 201-485-6060
            </a>
          </div>
        </div>
      </div>
      <div class="mt-8 pt-8 border-t border-blue-800">
        <p class="text-sm text-blue-200 text-center">
          © {{ new Date().getFullYear() }} Fairmont Park LLC. All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>

import {Phone} from 'lucide-vue-next';

export default {
  name: "FooterGlobal",
  components: {

    Phone,
  },
};
</script>